import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export interface LookupMgmtUnits {
  typeID?: number;
}

export const lookupMgmtUnits = async (params: LookupMgmtUnits) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/managementunits${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
